import React from 'react';
import { useParams } from 'react-router-dom';
import styled from '@emotion/styled';
import { VerificationStatus } from './components/VerificationStatus';
import { CategoryProfile } from './components/CategoryProfile';
import { ProductCard } from './components/ProductCard';
import { ActionButton } from './components/ActionButton';
import { URCodeFooter } from './components/URCodeFooter';
import { useProductData } from './hooks/useProductData';
import bgImage from './assets/bgimg.png';

// interface ProductVerificationParams {
//   productId: string;
// }

const ProductVerificationPage: React.FC = () => {
  // const { productId } = useParams<ProductVerificationParams>();
  const { productId } = useParams<{ productId: string }>();
  const { product, loading, error } = useProductData(productId);

  if (loading) {
    return (
      <Container>
        <ContentWrapper>
          <LoadingText>제품 정보를 불러오는 중입니다...</LoadingText>
        </ContentWrapper>
      </Container>
    );
  }

  if (error || !product) {
    return (
      <Container>
        <ContentWrapper>
          <ErrorText>
            {error?.message || '제품 정보를 찾을 수 없습니다.'}
          </ErrorText>
        </ContentWrapper>
      </Container>
    );
  }

  return (
    <Container>
      <ContentWrapper>
        <ContentArea>
          <VerificationStatus isAuthentic={product.isAuthentic} />
          
          <CategoryProfile 
            name={product.category.name}
            tag={product.category.tag}
          />
          
          <ProductCard
            category={product.product.type}
            name={product.product.name}
            details={product.product.details}
            image={product.product.image}
          />
          
          <ActionButton 
            url={product.connectUrl} 
            text={product.buttonText || "판매 페이지로 이동"}
          />
          
          <URCodeFooter />
        </ContentArea>
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #f5f8fb;
  display: flex;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 480px;
  position: relative;
  z-index: 1;
  background-image: url(${bgImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  
  @media (min-width: 1024px) {
    max-width: 480px;
    background-size: 100% 100%;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  }
`;

const ContentArea = styled.div`
  width: 100%;
  padding: 24px 16px 32px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  
  /* 모바일 최적화 */
  @media (max-width: 480px) {
    padding: 20px 12px 32px;
  }
  
  /* 작은 화면 최적화 */
  @media (max-width: 320px) {
    padding: 16px 10px 32px;
  }
`;

const LoadingText = styled.div`
  text-align: center;
  margin-top: 40px;
  font-size: 16px;
  color: #666;
  padding: 24px 16px;
`;

const ErrorText = styled.div`
  text-align: center;
  margin-top: 40px;
  font-size: 16px;
  color: #e74c3c;
  padding: 24px 16px;
`;

export default ProductVerificationPage;